/**
 * Site menu (mobile)
 * Opens and closes the header drawer below lg.
 *
 * The drawer is already in the document; this only toggles state.
 *
 * @package StandOut
 * @since 2.0.0
 */
import { $, $$ } from "@utils/dom";
import { trapFocus } from "@utils/focus-trap";
const OPEN_CLASS = "is-open";
const BODY_CLASS = "site-menu-open";
export const initSiteMenu = () => {
    const menu = $("#site-menu");
    const toggles = $$(".hero-slider__toggle");
    if (!menu || toggles.length === 0) {
        return;
    }
    const close = $(".site-menu__close", menu);
    let releaseTrap = null;
    const setOpen = (open) => {
        menu.classList.toggle(OPEN_CLASS, open);
        document.body.classList.toggle(BODY_CLASS, open);
        toggles.forEach((toggle) => {
            toggle.setAttribute("aria-expanded", String(open));
        });
        releaseTrap?.();
        releaseTrap = open ? trapFocus(menu) : null;
        // Move focus with the panel.
        if (open) {
            close?.focus();
        }
        else {
            toggles[0]?.focus();
        }
    };
    toggles.forEach((toggle) => {
        toggle.addEventListener("click", () => {
            setOpen(!menu.classList.contains(OPEN_CLASS));
        });
    });
    close?.addEventListener("click", () => setOpen(false));
    document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && menu.classList.contains(OPEN_CLASS)) {
            setOpen(false);
        }
    });
    // Resizing past the breakpoint would otherwise leave the body scroll-locked.
    // 1360px is the nav's own seam (--breakpoint-nav in main.css), not lg — keep
    // the two in step.
    const desktop = window.matchMedia("(min-width: 1360px)");
    desktop.addEventListener("change", (event) => {
        if (event.matches && menu.classList.contains(OPEN_CLASS)) {
            // Not setOpen(false): the hamburger is display:none past the seam,
            // so the focus return would go nowhere. Reset the state by hand.
            menu.classList.remove(OPEN_CLASS);
            document.body.classList.remove(BODY_CLASS);
            toggles.forEach((toggle) => {
                toggle.setAttribute("aria-expanded", "false");
            });
            releaseTrap?.();
            releaseTrap = null;
        }
    });
};
